import React, {Component} from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import translate from '../service/translation';
import PaginationCount from './PaginationCount';
import ExtendedFilterToggle from "./ExtendedFilterToggle";
import MultiSelectFilter from "./MultiSelectFilter";

class FilterForm extends Component {

    static propTypes = {
        handleInputChange: PropTypes.func.isRequired,
        resetFilterForm: PropTypes.func.isRequired,
        filter: PropTypes.object,
        categories: PropTypes.array,
        additionalCategories: PropTypes.array,
        total: PropTypes.string,
        renderedItems: PropTypes.string,
        EXTKEY: PropTypes.string
    };

    initialState = {
        extendedFilter: false
    };

    constructor(props) {
        super(props);

        this.state = this.initialState;
    }

    render() {
        const {filter, categories, additionalCategories, total, renderedItems, EXTKEY} = this.props;
        const {extendedFilter} = this.state;

        const hasCategories = categories !== undefined && categories.length !== 0;
        const hasAdditionalCategories = additionalCategories !== undefined && additionalCategories.length !== 0;

        return (
            <div className={EXTKEY + '__wrapper--filter'}>
                <div className={EXTKEY + '__filter--row row'}>
                    <div className={EXTKEY + '__form-group form-group col-auto'}>
                        <label htmlFor={EXTKEY + '-list_filter_search'} className="sr-only">
                            {translate('list_filter_label_search')}
                        </label>
                        <input type="text" value={filter.search} onChange={(event) => this.props.handleInputChange(event.target.value, 'search')}
                               placeholder={translate('list_filter_label_search')}
                               id={EXTKEY + '-list_filter_search'} className={EXTKEY + '__form-control form-control'}/>
                    </div>

                    <div className={EXTKEY + '__form-group form-group col-auto'}>
                        <label htmlFor={EXTKEY + '-list_filter_date'} className="sr-only">
                            {translate('list_filter_label_date')}
                        </label>
                        <DatePicker
                            selected={filter.date}
                            onChange={(newValue) => this.props.handleInputChange(newValue, 'date')}
                            dateFormat="dd.MM.yyyy"
                            placeholderText={translate('list_filter_label_date')}
                            id={EXTKEY + '-list_filter_date'}
                            className={EXTKEY + '__form-control form-control'}
                            locale={window.nezzoagenda_language}
                        />
                    </div>
                </div>

                {extendedFilter && (hasCategories || hasAdditionalCategories) ?
                    <div className="extendedFilterContainer">
                        {hasCategories ?
                            <MultiSelectFilter options={categories} filterKey="categories" value={filter.categories} EXTKEY={EXTKEY} handleInputChange={this.props.handleInputChange} />
                            : null
                        }

                        {hasAdditionalCategories ?
                            <MultiSelectFilter options={additionalCategories} filterKey="additionalCategories" value={filter.additionalCategories} EXTKEY={EXTKEY} handleInputChange={this.props.handleInputChange} />
                            : null
                        }
                    </div>
                    : null
                }

                <div className={EXTKEY + '__filter--navigation ' + EXTKEY + '__wrapper--navigation'}>
                    {total ? <PaginationCount total={total} limit={renderedItems.length} EXTKEY={EXTKEY}/> : null}

                    <ExtendedFilterToggle extendedSearch={extendedFilter} onClick={(event) => this.setState({extendedFilter: !extendedFilter})} EXTKEY={EXTKEY} />

                    <button onClick={this.props.resetFilterForm}
                            className={EXTKEY + '__button ' + EXTKEY + '__button--reset btn btn-secondary'}>
                        <span className={EXTKEY + '__button--icon' + EXTKEY + '__icon--reset'}/>
                        {translate('list_filter_reset')}
                    </button>
                </div>
            </div>
        );
    }
}

export default FilterForm;



// WEBPACK FOOTER //
// ./React/src/components/FilterForm.js